// components/QuizTimer.js
import { useState, useEffect } from 'react';

const QuizTimer = ({ initialTime, onTimeUp }) => {
  const [timeLeft, setTimeLeft] = useState(initialTime);

  useEffect(() => {
    if (timeLeft <= 0) {
      onTimeUp();
      return;
    }

    const timer = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft, onTimeUp]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  return (
    <div className="quiz-timer">
      <div className={`timer-display ${timeLeft < 300 ? 'warning' : ''}`}>
        ⏱️ {formatTime(timeLeft)}
      </div>
    </div>
  );
};

export default QuizTimer;